/* eslint-disable */
import GraphQL from '../../../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IndexabilityBlockPrimaryQueryVariables = GraphQL.Exact<{
  legacyUrlId: GraphQL.Scalars['Int']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type IndexabilityBlockPrimaryQuery = { readonly __typename?: 'Query', readonly lookupPageByLegacyId: { readonly __typename?: 'Page', readonly id: CK.UrlId, readonly isDisallowedInRobotsTxt: boolean | null, readonly isHttps: boolean, readonly isInSitemap: boolean | null, readonly isPrioritized: boolean, readonly lastCheckedAt: CK.Timestamp | null, readonly pageType: GraphQL.PageType, readonly statusCode: number | null, readonly timeServerResponse: number | null, readonly pageTypeData: { readonly __typename?: 'PageTypeData', readonly isIndexable: boolean, readonly isIndexableDueToMetaRobots: boolean, readonly isIndexableDueToXRobotsTag: boolean, readonly linkCanonical: { readonly __typename?: 'LinkRelItem', readonly content: string | null, readonly isCrossdomain: boolean | null, readonly legacyUrlId: number | null, readonly position: number, readonly url: string | null } | null, readonly primaryProperties: { readonly __typename?: 'OnPageProperties', readonly metaBingbot: { readonly __typename?: 'ContentItemsCollection', readonly isExpectedToBeNonEmpty: boolean, readonly type: GraphQL.ContentType, readonly contentItems: ReadonlyArray<{ readonly __typename?: 'ContentItem', readonly content: string, readonly position: number }> }, readonly metaGooglebot: { readonly __typename?: 'ContentItemsCollection', readonly isExpectedToBeNonEmpty: boolean, readonly type: GraphQL.ContentType, readonly contentItems: ReadonlyArray<{ readonly __typename?: 'ContentItem', readonly content: string, readonly position: number }> }, readonly metaRobots: { readonly __typename?: 'ContentItemsCollection', readonly isExpectedToBeNonEmpty: boolean, readonly type: GraphQL.ContentType, readonly contentItems: ReadonlyArray<{ readonly __typename?: 'ContentItem', readonly content: string, readonly position: number }> }, readonly metaSlurp: { readonly __typename?: 'ContentItemsCollection', readonly isExpectedToBeNonEmpty: boolean, readonly type: GraphQL.ContentType, readonly contentItems: ReadonlyArray<{ readonly __typename?: 'ContentItem', readonly content: string, readonly position: number }> }, readonly metaYandex: { readonly __typename?: 'ContentItemsCollection', readonly isExpectedToBeNonEmpty: boolean, readonly type: GraphQL.ContentType, readonly contentItems: ReadonlyArray<{ readonly __typename?: 'ContentItem', readonly content: string, readonly position: number }> } }, readonly xRobotsTag: { readonly __typename?: 'ContentItemsCollection', readonly isExpectedToBeNonEmpty: boolean, readonly type: GraphQL.ContentType, readonly contentItems: ReadonlyArray<{ readonly __typename?: 'ContentItem', readonly content: string, readonly position: number }> } } | null, readonly referencedInSitemaps: ReadonlyArray<{ readonly __typename?: 'PageReferenceInSitemap', readonly sitemapUrl: string }> | null } | null };

export type IndexabilityBlockSrcQueryVariables = GraphQL.Exact<{
  legacyUrlId: GraphQL.Scalars['Int']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type IndexabilityBlockSrcQuery = { readonly __typename?: 'Query', readonly lookupPageByLegacyId: { readonly __typename?: 'Page', readonly id: CK.UrlId, readonly isPrioritized: boolean, readonly lastCheckedAt: CK.Timestamp | null, readonly pageType: GraphQL.PageType, readonly pageTypeData: { readonly __typename?: 'PageTypeData', readonly srcProperties: { readonly __typename?: 'OnPageProperties', readonly metaBingbot: { readonly __typename?: 'ContentItemsCollection', readonly isExpectedToBeNonEmpty: boolean, readonly type: GraphQL.ContentType, readonly contentItems: ReadonlyArray<{ readonly __typename?: 'ContentItem', readonly content: string, readonly position: number }> }, readonly metaGooglebot: { readonly __typename?: 'ContentItemsCollection', readonly isExpectedToBeNonEmpty: boolean, readonly type: GraphQL.ContentType, readonly contentItems: ReadonlyArray<{ readonly __typename?: 'ContentItem', readonly content: string, readonly position: number }> }, readonly metaRobots: { readonly __typename?: 'ContentItemsCollection', readonly isExpectedToBeNonEmpty: boolean, readonly type: GraphQL.ContentType, readonly contentItems: ReadonlyArray<{ readonly __typename?: 'ContentItem', readonly content: string, readonly position: number }> }, readonly metaSlurp: { readonly __typename?: 'ContentItemsCollection', readonly isExpectedToBeNonEmpty: boolean, readonly type: GraphQL.ContentType, readonly contentItems: ReadonlyArray<{ readonly __typename?: 'ContentItem', readonly content: string, readonly position: number }> }, readonly metaYandex: { readonly __typename?: 'ContentItemsCollection', readonly isExpectedToBeNonEmpty: boolean, readonly type: GraphQL.ContentType, readonly contentItems: ReadonlyArray<{ readonly __typename?: 'ContentItem', readonly content: string, readonly position: number }> } } } | null } | null };

export type IndexabilityPrimaryPropertiesFragmentFragment = { readonly __typename?: 'OnPageProperties', readonly metaBingbot: { readonly __typename?: 'ContentItemsCollection', readonly isExpectedToBeNonEmpty: boolean, readonly type: GraphQL.ContentType, readonly contentItems: ReadonlyArray<{ readonly __typename?: 'ContentItem', readonly content: string, readonly position: number }> }, readonly metaGooglebot: { readonly __typename?: 'ContentItemsCollection', readonly isExpectedToBeNonEmpty: boolean, readonly type: GraphQL.ContentType, readonly contentItems: ReadonlyArray<{ readonly __typename?: 'ContentItem', readonly content: string, readonly position: number }> }, readonly metaRobots: { readonly __typename?: 'ContentItemsCollection', readonly isExpectedToBeNonEmpty: boolean, readonly type: GraphQL.ContentType, readonly contentItems: ReadonlyArray<{ readonly __typename?: 'ContentItem', readonly content: string, readonly position: number }> }, readonly metaSlurp: { readonly __typename?: 'ContentItemsCollection', readonly isExpectedToBeNonEmpty: boolean, readonly type: GraphQL.ContentType, readonly contentItems: ReadonlyArray<{ readonly __typename?: 'ContentItem', readonly content: string, readonly position: number }> }, readonly metaYandex: { readonly __typename?: 'ContentItemsCollection', readonly isExpectedToBeNonEmpty: boolean, readonly type: GraphQL.ContentType, readonly contentItems: ReadonlyArray<{ readonly __typename?: 'ContentItem', readonly content: string, readonly position: number }> } };

export type ContentItemsCollectionFragmentFragment = { readonly __typename?: 'ContentItemsCollection', readonly isExpectedToBeNonEmpty: boolean, readonly type: GraphQL.ContentType, readonly contentItems: ReadonlyArray<{ readonly __typename?: 'ContentItem', readonly content: string, readonly position: number }> };

export const ContentItemsCollectionFragmentFragmentDoc = gql`
    fragment ContentItemsCollectionFragment on ContentItemsCollection {
  contentItems {
    content
    position
  }
  isExpectedToBeNonEmpty
  type
}
    `;
export const IndexabilityPrimaryPropertiesFragmentFragmentDoc = gql`
    fragment IndexabilityPrimaryPropertiesFragment on OnPageProperties {
  metaBingbot {
    ...ContentItemsCollectionFragment
  }
  metaGooglebot {
    ...ContentItemsCollectionFragment
  }
  metaRobots {
    ...ContentItemsCollectionFragment
  }
  metaSlurp {
    ...ContentItemsCollectionFragment
  }
  metaYandex {
    ...ContentItemsCollectionFragment
  }
}
    ${ContentItemsCollectionFragmentFragmentDoc}`;
export const IndexabilityBlockPrimaryDocument = gql`
    query IndexabilityBlockPrimary($legacyUrlId: Int!, $websiteId: WebsiteId!) {
  lookupPageByLegacyId(legacyUrlId: $legacyUrlId, websiteId: $websiteId) {
    id
    isDisallowedInRobotsTxt
    isHttps
    isInSitemap
    isPrioritized
    lastCheckedAt
    pageType
    pageTypeData {
      isIndexable
      isIndexableDueToMetaRobots
      isIndexableDueToXRobotsTag
      linkCanonical {
        content
        isCrossdomain
        legacyUrlId
        position
        url
      }
      primaryProperties {
        ...IndexabilityPrimaryPropertiesFragment
      }
      xRobotsTag {
        ...ContentItemsCollectionFragment
      }
    }
    referencedInSitemaps {
      sitemapUrl
    }
    statusCode
    timeServerResponse
  }
}
    ${IndexabilityPrimaryPropertiesFragmentFragmentDoc}
${ContentItemsCollectionFragmentFragmentDoc}`;

/**
 * __useIndexabilityBlockPrimaryQuery__
 *
 * To run a query within a React component, call `useIndexabilityBlockPrimaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndexabilityBlockPrimaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndexabilityBlockPrimaryQuery({
 *   variables: {
 *      legacyUrlId: // value for 'legacyUrlId'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useIndexabilityBlockPrimaryQuery(baseOptions: Apollo.QueryHookOptions<IndexabilityBlockPrimaryQuery, IndexabilityBlockPrimaryQueryVariables> & ({ variables: IndexabilityBlockPrimaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndexabilityBlockPrimaryQuery, IndexabilityBlockPrimaryQueryVariables>(IndexabilityBlockPrimaryDocument, options);
      }
export function useIndexabilityBlockPrimaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndexabilityBlockPrimaryQuery, IndexabilityBlockPrimaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndexabilityBlockPrimaryQuery, IndexabilityBlockPrimaryQueryVariables>(IndexabilityBlockPrimaryDocument, options);
        }
export function useIndexabilityBlockPrimarySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IndexabilityBlockPrimaryQuery, IndexabilityBlockPrimaryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndexabilityBlockPrimaryQuery, IndexabilityBlockPrimaryQueryVariables>(IndexabilityBlockPrimaryDocument, options);
        }
export type IndexabilityBlockPrimaryQueryHookResult = ReturnType<typeof useIndexabilityBlockPrimaryQuery>;
export type IndexabilityBlockPrimaryLazyQueryHookResult = ReturnType<typeof useIndexabilityBlockPrimaryLazyQuery>;
export type IndexabilityBlockPrimarySuspenseQueryHookResult = ReturnType<typeof useIndexabilityBlockPrimarySuspenseQuery>;
export type IndexabilityBlockPrimaryQueryResult = Apollo.QueryResult<IndexabilityBlockPrimaryQuery, IndexabilityBlockPrimaryQueryVariables>;
export const IndexabilityBlockSrcDocument = gql`
    query IndexabilityBlockSrc($legacyUrlId: Int!, $websiteId: WebsiteId!) {
  lookupPageByLegacyId(legacyUrlId: $legacyUrlId, websiteId: $websiteId) {
    id
    isPrioritized
    lastCheckedAt
    pageType
    pageTypeData {
      srcProperties {
        ...IndexabilityPrimaryPropertiesFragment
      }
    }
  }
}
    ${IndexabilityPrimaryPropertiesFragmentFragmentDoc}`;

/**
 * __useIndexabilityBlockSrcQuery__
 *
 * To run a query within a React component, call `useIndexabilityBlockSrcQuery` and pass it any options that fit your needs.
 * When your component renders, `useIndexabilityBlockSrcQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIndexabilityBlockSrcQuery({
 *   variables: {
 *      legacyUrlId: // value for 'legacyUrlId'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useIndexabilityBlockSrcQuery(baseOptions: Apollo.QueryHookOptions<IndexabilityBlockSrcQuery, IndexabilityBlockSrcQueryVariables> & ({ variables: IndexabilityBlockSrcQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IndexabilityBlockSrcQuery, IndexabilityBlockSrcQueryVariables>(IndexabilityBlockSrcDocument, options);
      }
export function useIndexabilityBlockSrcLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IndexabilityBlockSrcQuery, IndexabilityBlockSrcQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IndexabilityBlockSrcQuery, IndexabilityBlockSrcQueryVariables>(IndexabilityBlockSrcDocument, options);
        }
export function useIndexabilityBlockSrcSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IndexabilityBlockSrcQuery, IndexabilityBlockSrcQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IndexabilityBlockSrcQuery, IndexabilityBlockSrcQueryVariables>(IndexabilityBlockSrcDocument, options);
        }
export type IndexabilityBlockSrcQueryHookResult = ReturnType<typeof useIndexabilityBlockSrcQuery>;
export type IndexabilityBlockSrcLazyQueryHookResult = ReturnType<typeof useIndexabilityBlockSrcLazyQuery>;
export type IndexabilityBlockSrcSuspenseQueryHookResult = ReturnType<typeof useIndexabilityBlockSrcSuspenseQuery>;
export type IndexabilityBlockSrcQueryResult = Apollo.QueryResult<IndexabilityBlockSrcQuery, IndexabilityBlockSrcQueryVariables>;